import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import Loading from "../../components/Loading";
import Data from '../../../repository';

import styles from '../../../styles/Admin.module.scss';

function List() {
	const [loading, setLoading] = useState(true);
	const [staff, setStaff] = useState([]);
	const [search, setSearch] = useState("");

	useEffect(() => {
		refreshStaff();
	}, [])

	const refreshStaff = async () => {
		setLoading(true);
		try {
			const res = await Data.fetchStaff();
			setStaff(res.data);
		} catch (error) {
			console.error('Error fetching staff:', error);
		}
		setLoading(false);
	}

	if (loading) return <Loading button={false} />

	const filteredStaff = staff.filter((member) => {
		const query = `${member.firstName} ${member.lastName}`.toLowerCase();
		return query.includes(search.toLowerCase());
	});

	return (
		<div className={styles.list}>
			<input
				type="text"
				value={search}
				onChange={(e) => setSearch(e.target.value)}
				placeholder="Search staff..."
			/>

			{!filteredStaff.length && !search && (
				<div>
					<p>No staff members yet.</p>
					<Link to="create" className="btn btnPrimary" style={{ marginTop: '16px', display: 'inline-block' }}>
						Add your first staff member
					</Link>
				</div>
			)}

			{!filteredStaff.length && search && (
				<div><p>No staff found matching "{search}"</p></div>
			)}

			{filteredStaff.map((member) => (
				<div key={member._id} className={`${styles.staff} ${!member.enabled ? styles.disabled : ''}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
					<Link to={member._id} style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, textDecoration: 'none', color: 'inherit' }}>
						<div style={{
							width: '40px',
							height: '40px',
							borderRadius: '50%',
							background: member.image ? '#f5f5f5' : 'var(--primary-color)',
							color: 'white',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontWeight: '600',
							flexShrink: 0,
							overflow: 'hidden'
						}}>
							{member.image ? (
								<img
									src={member.image}
									alt={`${member.firstName} ${member.lastName}`}
									style={{ width: '100%', height: '100%', objectFit: 'cover' }}
								/>
							) : (
								<>{member.firstName?.charAt(0)}{member.lastName?.charAt(0)}</>
							)}
						</div>
						<div>
							<p><strong>{member.firstName} {member.lastName}</strong></p>
							{member.title && <p style={{ fontSize: '14px', opacity: 0.6 }}>{member.title}</p>}
						</div>
					</Link>
					<p style={{
						padding: '4px 12px',
						borderRadius: '20px',
						fontSize: '12px',
						background: member.enabled ? '#E8F5E9' : '#eee',
						color: member.enabled ? '#2E7D32' : '#666'
					}}>
						{member.enabled ? 'Active' : 'Inactive'}
					</p>
					<Link to={`${member._id}/report`} className="btn" style={{ whiteSpace: 'nowrap' }}>
						Pay Report
					</Link>
				</div>
			))}
		</div>
	)
}

export default List;
